import { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import RegularQuoteForm from './regularQuoteForm';
import apiServices from '../../../services/service';
import { fetchDataAndUpdateStore, singleRowAddUpdateInStore } from '../../../redux/actions';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { initValueQuote } from '../../../shared/initials';
import Loader from '../../../shared/component/Loader';
import { getProductList, getUser } from '../../../redux/selector';
import { validationSchemaQuote } from './validationSchema';

const CL_ICONS = {
  chevL: <path d="M15 18l-6-6 6-6" />,
  check: <path d="M20 6 9 17l-5-5" />,
};
const CLIc = ({ name, size = 16, style }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" style={style}>
    {CL_ICONS[name] || null}
  </svg>
);

const RegularQuoteEdit = () => {
  const [deletePopup, setDeletePopup] = useState(false);
  const [imageUrl, setImageUrl] = useState('/assets/images/crm/add-image-placeholder.svg');
  const userInfo = useSelector(getUser);
  if (!initValueQuote.quoteOwner) {
    initValueQuote.quoteOwner = userInfo?.user?.display_name;
    initValueQuote.quoteOwnerId = userInfo?.user?.userId;
  }
  const [loading, setLoading] = useState(false);
  const [enrichedDataLoading, setEnrichedDataLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('overview');
  const [formData, setFormData] = useState(initValueQuote);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [showPopup6, setShowPopup6] = useState(false);
  const [selectedNote, setSelectedNote] = useState([]);
  const [productsByAccountId, setProductByAccountId] = useState([]);
  const productList = useSelector(getProductList);
  const [priceSheetByProductId, setPriceSheetByProductId] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const refs = {
    overview: useRef(null),
    salesOrder: useRef(null),
    attachments: useRef(null),
    emails: useRef(null),
    timeline: useRef(null),
  };
  const scrollToSection = (id) => {
    if (refs[id]?.current) {
      refs[id].current.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'center', // Aligns the section close to the center
        inline: 'nearest',
      });

      // Slightly adjust the position to be a bit above the center
      setTimeout(() => {
        const offset = -50; // Adjust this value for how much higher you want
        const elementPosition =
          refs[id].current.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }, 300); // Adjust timeout if necessary for smoother behavior
    }
  };

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      root: scrollContainerRef.current,
      rootMargin: '0px 0px -250px 0px', // Adjusts the bottom margin to trigger when the section is halfway through the viewport
      threshold: 0,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          setActiveTab(sectionId);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe each section
    Object.values(refs).forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });
  });

  const handlePopupDelete = (note) => {
    setSelectedNote(note); // Store the note to delete
    setDeletePopup(true); // Open the delete confirmation popup
  };

  useEffect(() => {
    console.log('Active Tab:', activeTab);
  }, [activeTab]);

  const handleClickDataEnrichment = () => {
    setEnrichedDataLoading(true);
  };


  const handleCloseForm = () => {
    if(formData?.from === "view"){
      navigate(`/quoteAI/regularQuoteView?id=${formData?.id}`);
    } else
    navigate('/quoteAI');
  };

  // const handleChangeForm = (e, rowIndex, changeFrom) => {
  //     if (changeFrom !== "SalesOrderd") {
  //       const { name, value } = e.target;
  //       const convertedValue = value;
  //       setFormData({
  //         ...formData,
  //         [name]: convertedValue,
  //       });
  //     }

  //     setFormData((prev) => {
  //       const updatedItems = [...prev.quoteDetails];
  //       const updatedRow = { ...updatedItems[rowIndex] };
  //       const quantity = Number(updatedRow.quantity) || 0;
  //       const listPrice = Number(updatedRow.listPrice) || 0;
  //       const discount = Number(updatedRow.discountPercent) || 0;
  //       const tax = Number(updatedRow.taxPercent) || 0;

  //       const amount = quantity * listPrice;
  //       const discountAmount = (amount * discount) / 100;
  //       const taxAmount = (amount * tax) / 100;
  //       const lineTotal = amount - discountAmount + taxAmount;
  //       updatedRow.amount = amount;
  //       updatedRow.lineTotal = lineTotal;

  //       updatedItems[rowIndex] = updatedRow;

  //       const updatedWithLineNumbers = updatedItems.map((item, index) => ({
  //         ...item,
  //         lineNumber: index + 1,
  //       }));

  //       const subTotal = updatedWithLineNumbers.reduce(
  //         (sum, item) => sum + (item.amount || 0),
  //         0
  //       );
  //       const discountTotal = updatedWithLineNumbers.reduce(
  //         (sum, item) =>
  //           sum + ((item.amount || 0) * (item.discountPercent || 0)) / 100,
  //         0
  //       );
  //       const taxTotal = updatedWithLineNumbers.reduce(
  //         (sum, item) =>
  //           sum + ((item.amount || 0) * (item.taxPercent || 0)) / 100,
  //         0
  //       );

  //       const adjustment = Number(prev.adjustment) || 0;
  //       const grandTotal = subTotal - discountTotal + taxTotal + adjustment;
  //       console.log(" ...prev 92 ", prev, updatedWithLineNumbers);
  //       return {
  //         ...prev,
  //         quoteDetails: updatedWithLineNumbers,
  //         subTotal,
  //         discountTotal,
  //         taxTotal,
  //         grandTotal,
  //       };
  //     });
  //   };

  const calculateQuoteTotals = (quoteDetails, adjustment = 0) => {
    const updatedWithCalcs = quoteDetails.map((item, index) => {
      const quantity = Number(item.quantity) || 0;
      const listPrice = Number(item.listPrice) || 0;
      const amount = quantity * listPrice;

      let discountPercent = Number(item.discountPercent) || 0;
      let discountAmount = Number(item.discountAmount) || 0;
      if (discountAmount && !discountPercent) {
        discountPercent = (discountAmount / amount) * 100;
      } else {
        discountAmount = (amount * discountPercent) / 100;
      }

      let taxPercent = Number(item.taxPercent) || 0;
      let taxAmount = Number(item.taxAmount) || 0;
      if (taxAmount && !taxPercent) {
        taxPercent = (taxAmount / amount) * 100;
      } else {
        taxAmount = (amount * taxPercent) / 100;
      }

      const lineTotal = amount - discountAmount + taxAmount;

      return {
        ...item,
        quantity,
        listPrice,
        amount,
        discountPercent,
        discountAmount,
        taxPercent,
        taxAmount,
        lineTotal,
        lineNumber: index + 1,
      };
    });

    const subTotal = updatedWithCalcs.reduce((sum, item) => sum + (item.amount || 0), 0);
    const discountTotal = updatedWithCalcs.reduce(
      (sum, item) => sum + (item.discountAmount || 0),
      0
    );
    const taxTotal = updatedWithCalcs.reduce((sum, item) => sum + (item.taxAmount || 0), 0);
    const grandTotal = subTotal - discountTotal + taxTotal + Number(adjustment || 0);

    return {
      quoteDetails: updatedWithCalcs,
      subTotal,
      discountTotal,
      taxTotal,
      grandTotal,
    };
  };

  const handleChangeForm = (e, rowIndex, changeFrom) => {
    // Handle non-quoteDetails field changes
    if (changeFrom !== 'quoteDetails') {
      const { name, value } = e.target;

      return setFormData((prev) => {
        const updated = {
          ...prev,
          [name]: name === 'adjustment' ? parseFloat(value) || 0 : value,
        };

        // Recalculate totals if adjustment changes
        if (name === 'adjustment') {
          const totals = calculateQuoteTotals(prev.quoteDetails || [], updated.adjustment);
          return { ...updated, ...totals };
        }

        return updated;
      });
    }

    // Handle quoteDetails row updates
    setFormData((prev) => {
      const updatedItems = [...prev.quoteDetails];
      const updatedRow = { ...updatedItems[rowIndex], ...e };
      updatedItems[rowIndex] = updatedRow;

      const totals = calculateQuoteTotals(updatedItems, prev.adjustment);

      return {
        ...prev,
        ...totals,
      };
    });
  };

  // const handleChangeForm = (e, rowIndex, changeFrom) => {
  //   if (changeFrom !== "quoteDetails") {
  //     const { name, value } = e.target;
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   }

  //   setFormData((prev) => {
  //     const updatedItems = [...prev.quoteDetails];
  //     const updatedRow = { ...updatedItems[rowIndex] };

  //     const quantity = Number(updatedRow.quantity) || 0;
  //     const listPrice = Number(updatedRow.listPrice) || 0;
  //     const amount = quantity * listPrice;

  //     // Discount logic
  //     let discountPercent = Number(updatedRow.discountPercent) || 0;
  //     let discountAmount = Number(updatedRow.discountAmount) || 0;
  //     if (discountAmount && !discountPercent) {
  //       discountPercent = (discountAmount / amount) * 100;
  //     } else {
  //       discountAmount = (amount * discountPercent) / 100;
  //     }

  //     // Tax logic
  //     let taxPercent = Number(updatedRow.taxPercent) || 0;
  //     let taxAmount = Number(updatedRow.taxAmount) || 0;
  //     if (taxAmount && !taxPercent) {
  //       taxPercent = (taxAmount / amount) * 100;
  //     } else {
  //       taxAmount = (amount * taxPercent) / 100;
  //     }

  //     const lineTotal = amount - discountAmount + taxAmount;

  //     // Update row
  //     updatedRow.amount = amount;
  //     updatedRow.discountPercent = discountPercent;
  //     updatedRow.discountAmount = discountAmount;
  //     updatedRow.taxPercent = taxPercent;
  //     updatedRow.taxAmount = taxAmount;
  //     updatedRow.lineTotal = lineTotal;

  //     updatedItems[rowIndex] = updatedRow;

  //     const updatedWithLineNumbers = updatedItems.map((item, index) => ({
  //       ...item,
  //       lineNumber: index + 1,
  //     }));

  //     const subTotal = updatedWithLineNumbers.reduce(
  //       (sum, item) => sum + (item.amount || 0),
  //       0
  //     );
  //     const discountTotal = updatedWithLineNumbers.reduce(
  //       (sum, item) => sum + (item.discountAmount || 0),
  //       0
  //     );
  //     const taxTotal = updatedWithLineNumbers.reduce(
  //       (sum, item) => sum + (item.taxAmount || 0),
  //       0
  //     );

  //     const adjustment = Number(prev.adjustment) || 0;
  //     const grandTotal = subTotal - discountTotal + taxTotal + adjustment;

  //     return {
  //       ...prev,
  //       quoteDetails: updatedWithLineNumbers,
  //       subTotal,
  //       discountTotal,
  //       taxTotal,
  //       grandTotal,
  //     };
  //   });
  // };

  const handleAddRow = () => {
    setFormData((prev) => ({
      ...prev,
      quoteDetails: [
        ...(prev.quoteDetails || []),
        {
          id: '',
          productName: '',
          description: '',
          quantity: 0,
          listPrice: 0,
          discountAmount: 0,
          amount: 0,
          discountPercent: 0,
          taxPercent: 0,
          taxAmount: 0,
          lineNumber: 0,
          lineTotal: 0,
          quoteId: formData?.id,
        },
      ],
    }));
  };

  const handleAddProductToQuoteItems = (selectedProducts) => {
    setFormData((prev) => {
      const updatedQuoteItems = (prev.quoteDetails || []).map((item) => {
        const matchedProduct = selectedProducts.find((p) => p.productId === item.productId);

        if (matchedProduct) {
          return {
            ...item,
            listPrice: matchedProduct.listPrice,
          };
        }

        return item;
      });

      const totals = calculateQuoteTotals(updatedQuoteItems, prev.adjustment);

      return {
        ...prev,
        quoteDetails: updatedQuoteItems,
        ...totals,
      };
    });

    setLoading(false);
  };

  const getInvoiceSalesOrderDetailsDelete = (id, index) => {
  if (id) {
    // Call API if id is present
    const data = { id: [id] };

    apiServices
      .getInvoiceSalesOrderDetailsDeleteById(data)
      .then((response) => {
        if (response.status === 200) {
          deleteRow(index);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  } else {
    // No ID, just delete the row locally
    deleteRow(index);
  }
};

// Reusable function to remove a row and re-index lineNumbers
const deleteRow = (index) => {
  setFormData((prev) => {
    if (prev.quoteDetails.length <= 1) {
      toast.warn('At least one row is required.', {
        position: 'top-right',
      });
      return prev; // Prevent deleting the last row
    }

    const updatedItems = prev.quoteDetails.filter((_, i) => i !== index);
    return {
      ...prev,
      quoteDetails: updatedItems.map((item, idx) => ({
        ...item,
        lineNumber: idx + 1,
      })),
    };
  });
};

// ✅ Function to handle checkbox toggle
const handleSameAsBillingChange = (e) => {
  const checked = e.target.checked;

  setFormData((prev) => ({
    ...prev,
    sameAsBilling: checked,
    ...(checked
      ? {
          shippingStreet: prev.billingStreet || "",
          shippingCity: prev.billingCity || "",
          shippingState: prev.billingState || "",
          shippingCountry: prev.billingCountry || "",
          shippingCode: prev.billingCode || "",
        }
      : {
          shippingStreet: "",
          shippingCity: "",
          shippingState: "",
          shippingCountry: "",
          shippingCode: "",
        }),
  }));
};


  // const handleDeleteRow = (index) => {
  //   setFormData((prev) => {
  //     if (prev.quoteDetails.length <= 1) {
  //       // Optionally, show a warning/toast here
  //       return prev; // Don't delete the last remaining row
  //     }

  //     const updatedItems = prev.quoteDetails.filter((_, i) => i !== index);
  //     return {
  //       ...prev,
  //       quoteDetails: updatedItems.map((item, idx) => ({
  //         ...item,
  //         lineNumber: idx + 1,
  //       })),
  //     };
  //   });
  // };

  const updateList = async (msg, id) => {
    setLoading(false);

    toast.success(msg, {
      position: 'top-right',
    });

    const columnName = 'UpdatedDateTime';
    const orderType = 'desc';
    const data = {
      pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
      pageNumber: 1,
      columnName,
      orderType,
      filterJson: null,
    };

    try {
      // ✅ Await the dispatch before navigation
      // await dispatch(
      //   fetchDataAndUpdateStore({ key: "quoteList", inputData: data })
      // );
      dispatch(
        singleRowAddUpdateInStore({
          moduleName: 'Quote',
          moduleKey: "quoteList",
          id: formData.type === 'add' ? id : formData.id,
          rowIndex: formData.rowIndex,
        })
      );
      if (formData.from === 'view') {
        navigate(`/quoteAI/regularQuoteView?id=${formData.id}`);
      } else {
        navigate('/quoteAI');
      }
    } catch (error) {
      console.error('Failed to fetch and update leads:', error);
      toast.error('Something went wrong while updating the list.', {
        position: 'top-right',
      });
    }
  };

  const handleFormSubmit = async (formData) => {
    setLoading(true);

    if (formData.type === 'add') {
      apiServices
        .createQuote(formData)
        .then((response) => {
          if (response.status === 200) {
            const id = response.data;
            updateList('Quote created successfully!',id);
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                errorMessages.push(...response.errors[key]);
              }
            }
            errorMessages.forEach((msg) => toast.error(msg, { position: 'top-right' }));
          }
        })
        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    } else {
      try {
        // Create a shallow copy excluding quoteDetails
        const { quoteDetails, ...quoteOnlyData } = formData;

        // First update main quote data
        const quoteResponse = await apiServices.updateQuote(quoteOnlyData);

        if (quoteResponse.status === 200) {
          // Then update quoteDetails separately
          const quoteItemsPayload = {
            quoteDetailList: quoteDetails || [],
          };

          const itemUpdateRes = await apiServices.updateMultipleQuoteDetails(quoteItemsPayload);

          if (itemUpdateRes.status === 200) {
            updateList('Quote updated successfully!');
          } else {
            toast.error('Quote details update failed.', {
              position: 'top-right',
            });
          }
        } else {
          const errorMessages = [];
          for (const key in quoteResponse.errors) {
            if (quoteResponse.errors.hasOwnProperty(key)) {
              errorMessages.push(...quoteResponse.errors[key]);
            }
          }
          errorMessages.forEach((msg) => toast.error(msg, { position: 'top-right' }));
        }
      } catch (error) {
        console.error('Update error:', error, 'DataFormat:', formData);
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const fetchAccountDetails = (accountId) => {
    apiServices
      .getProductsByAccountId(accountId)
      .then((response) => {
        if (response.status === 200) {
          setProductByAccountId(response?.data?.productAccountAssociations);
        }
      })
      .catch((error) => {
        console.error('Error fetching account details:', error);
      });
  };

  const handleChange = (selectedOption, name, rowIndex = null) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    setFormEdited(true);
    handleLookupDropDownChange(selectedOption.value, selectedOption, name, rowIndex);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name, rowIndex = null) => {
    const selectedValue = selectedOption.label;

    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));

    const updatedFields = {
      accountId: (prev) => {
        // fetchAccountDetails(selectedId);
        return { ...prev, accountId: selectedId, accountName: selectedValue };
      },
      quoteOwnerId: (prev) => ({
        ...prev,
        quoteOwnerId: selectedId,
        quoteOwner: selectedValue,
      }),
      carrierId: (prev) => ({
        ...prev,
        carrierId: selectedId,
        carrier: selectedValue,
      }),
      quoteStageId: (prev) => ({
        ...prev,
        quoteStageId: selectedId,
        quoteStage: selectedValue,
      }),
      opportunityId: (prev) => ({
        ...prev,
        opportunityId: selectedId,
        opportunity: selectedValue,
      }),
      contactId: (prev) => ({
        ...prev,
        contactId: selectedId,
        contactName: selectedValue,
      }),
      productId: (prev) => {
        const selectedProduct = productList.find((p) => p.id === selectedId);

        const updatedQuoteItems = [...prev.quoteDetails];
        const currentRow = updatedQuoteItems[rowIndex] || {};

        updatedQuoteItems[rowIndex] = {
          ...currentRow,
          productId: selectedId,
          productName: selectedValue,
          listPrice: selectedProduct?.unitPrice || 0,
        };

        const totals = calculateQuoteTotals(updatedQuoteItems, prev.adjustment);

        return {
          ...prev,
          ...totals,
        };
      },
    };

    if (updatedFields[name]) {
      setFormData((prevData) => updatedFields[name](prevData));
      setFormEdited(true);
    }
  };

  const states = ['state1', 'state2'];

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      // Remove "https://" and "www." from relevant fields
      const sanitizedData = {
        ...formData,
      };
      // console.log("🚀 ~ handleSubmit ~ sanitizedData:", sanitizedData)

      await validationSchemaQuote.validate(sanitizedData, { abortEarly: false });
      handleFormSubmit(sanitizedData);
    } catch (error) {
      setLoading(false);
      const fieldErrors = {};
      error.inner.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      const errorFields = Object.keys(fieldErrors);
      console.log('text', errorFields);
      if (errorFields.length > 0) {
        const firstErrorKey = errorFields[0];
        const errorRef = refs[firstErrorKey];
        console.log('errorRef', errorRef);
        if (errorRef?.current) {
          errorRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
          errorRef.current.focus();
        }
      } else {
        // Submit the form!
      }

      console.error('Validation Error:', fieldErrors);
    }
  };
  const closePopup6 = () => {
    setShowPopup6(false);
  };

  const openPopup6 = () => {
    setShowPopup6(true);
  };

  const handleClickDelete = () => {};
  const notescontainerRef = useRef(null);

  useEffect(() => {
    if (notescontainerRef.current) {
      notescontainerRef.current.scrollTop = notescontainerRef.current.scrollHeight;
    }
  }, []);

  function toTitleCaseFromCamel(str) {
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2') // inserts space before capital letters
      .replace(/^./, (char) => char.toUpperCase()); // capitalize the first letter
  }

  const handleCancelForm = () => {
    navigate('/quoteAI', {
      state: formData,
    });
  };

  useEffect(() => {
    const fetchQuoteDetails = async () => {
      let updatedFormData = {
        ...formData,
        type: location.pathname.includes('Add') ? 'add' : 'edit',
      };

      if (location.pathname.includes('Edit') && location.state) {
        setLoading(true);
        try {
          const response = await apiServices.getQuoteDetailsByQuoteId(location.state);

          if (response.status === 200) {
            const quoteDetails = response.data?.quoteDetails || [];

            updatedFormData = {
              ...location.state,
              quoteDetails,
              type: 'edit',
            };

            setFormData(updatedFormData);

            // ✅ Fetch products based on accountId
            if (location.state.accountId) {
              fetchAccountDetails(location.state.accountId);
            }

            setLoading(false);
          } else {
            console.error('Failed to fetch quote details:', response);
            setLoading(false);
          }
        } catch (err) {
          setLoading(false);
          console.error('API error in getQuoteDetailsByQuoteId:', err);
        }
      } else {
        setFormData(updatedFormData);
      }
    };

    fetchQuoteDetails();
  }, [location]);

  const isEdit = formData?.type === 'edit';
  const canSave = !!(formData?.subject && String(formData.subject).trim()) && !!formData?.accountId;

  return (
    <div className="gos-cl gos-quoteform">
      {loading && <Loader />}
      {/* sticky header */}
      <div className="gos-cl-header">
        <button type="button" className="gos-cl-back" onClick={handleCloseForm} title="Back to Quotes">
          <CLIc name="chevL" size={18} />
        </button>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="gos-cl-htitle">{isEdit ? 'Edit Quote' : 'Create New Quote'}</div>
          <div className="gos-cl-hsub">
            Fields marked <span className="gos-cl-reqdot">*</span> are required
          </div>
        </div>
        <button type="button" className="gos-btn gos-btn-ghost" onClick={handleCloseForm}>Cancel</button>
        <button
          type="button"
          className="gos-btn gos-btn-primary"
          onClick={() => handleSubmit(formData)}
          disabled={loading || !canSave}
          style={{ opacity: canSave ? 1 : 0.55 }}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Saving…
            </>
          ) : (
            <>
              <CLIc name="check" size={16} /> Save Quote
            </>
          )}
        </button>
      </div>

      <div className="gos-cl-scroll">
        <RegularQuoteForm
          formData={formData}
          handleChange={handleChange}
          handleChangeForm={handleChangeForm}
          handleAddRow={handleAddRow}
          handleDeleteRow={getInvoiceSalesOrderDetailsDelete}
          handleSameAsBillingChange={handleSameAsBillingChange}
          errormsg={errormsg}
        />
      </div>
    </div>
  );
};

export default RegularQuoteEdit;
